import { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isDemoMagicLinkRedirect } from '@/application/auth/clearClientSession';
import { useUserStore } from '@/stores/user/userStore';
import PageViewTracker from '@/components/PageViewTracker';
import RouteChangeHandler from '@/components/RouteChangeHandler';

const PublicRoute = ({ permission, children }) => {
  const { auth, user } = useUserStore();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const allowSetPasswordFromDemoMagicLink =
    location.pathname === '/set-password' && isDemoMagicLinkRedirect(searchParams);

  return auth.access_token && !user.should_redirect && !allowSetPasswordFromDemoMagicLink ? (
    <Navigate to="/" replace />
  ) : (
    <>
      <PageViewTracker />
      <RouteChangeHandler />
      <Suspense>{children}</Suspense>
    </>
  );
};

export default PublicRoute;
